import { PhoneNumber } from '../../models/serializable/phone-number.js';

export abstract class PhoneNumberFormatter {
  abstract format(phoneNumber: PhoneNumber): string;
}
